(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-collection"] && !Shopify.designMode) return;
  try {
    
  // Image slider functionality
  document.addEventListener('DOMContentLoaded', function() {
    const sectionElements = document.querySelectorAll('[data-section-id]');
    
    sectionElements.forEach(function(sectionElement) {
      const sectionId = sectionElement.getAttribute('data-section-id');
      const sectionSelector = '#shopify-section-' + sectionId;
      const sliders = sectionElement.querySelectorAll('.product-slider');

    sliders.forEach(slider => {
      const wrapper = slider.querySelector('.product-slider-wrapper');
      const slides = slider.querySelectorAll('.product-slide');
      const card = slider.closest('.product-card');
      const dots = card ? card.querySelectorAll('.dot') : [];
      
      if (slides.length <= 1) return;
      
      let currentSlide = 0;
      const slideCount = slides.length;
      
      // Touch swipe functionality
      let touchStartX = 0;
      let touchEndX = 0;
      
      slider.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
      }, {passive: true});
      
      slider.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
      }, {passive: true});
      
      function handleSwipe() {
        const threshold = 50;
        if (touchStartX - touchEndX > threshold) {
          currentSlide = Math.min(currentSlide + 1, slideCount - 1);
          updateSlider();
        } else if (touchEndX - touchStartX > threshold) {
          currentSlide = Math.max(currentSlide - 1, 0);
          updateSlider();
        }
      }
      
      function updateSlider() {
        wrapper.style.transform = `translateX(-${currentSlide * 100}%)`;
      }
    });

      // Collection filtering
      const collectionLinks = sectionElement.querySelectorAll('.collection-filter-link');
      const productCards = sectionElement.querySelectorAll('.product-card');
      
      collectionLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          collectionLinks.forEach(function(l) {
            l.classList.remove('active');
          });
          this.classList.add('active');
          
          const collectionHandle = this.getAttribute('data-collection');
          
          productCards.forEach(function(card) {
            const cardCollections = card.getAttribute('data-collection') || '';
            const shouldShow = collectionHandle === 'all' || cardCollections.includes(collectionHandle);
            card.style.display = shouldShow ? '' : 'none';
          });
        });
      });

      // Sort functionality
      const sortSelect = sectionElement.querySelector('.sort-by-dropdown select');
      if (sortSelect) {
        sortSelect.addEventListener('change', function() {
          const selectedSort = this.value;
          const productGrid = sectionElement.querySelector('.product-grid');
          const visibleProducts = Array.from(productCards).filter(function(card) {
            return card.style.display !== 'none';
          });
          
          visibleProducts.sort(function(a, b) {
            switch(selectedSort) {
              case 'price-ascending':
                return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
              case 'price-descending':
                return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
              case 'title-ascending':
                return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
              case 'title-descending':
                return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title'));
              case 'created-ascending':
                return parseInt(a.getAttribute('data-created')) - parseInt(b.getAttribute('data-created'));
              case 'created-descending':
                return parseInt(b.getAttribute('data-created')) - parseInt(a.getAttribute('data-created'));
              default:
                return parseInt(a.getAttribute('data-index')) - parseInt(b.getAttribute('data-index'));
            }
          });
          
          visibleProducts.forEach(function(product) {
            productGrid.appendChild(product);
          });
        });
      }

      // Search functionality
      const searchInput = sectionElement.querySelector('.product-search-input');
      const searchClear = sectionElement.querySelector('.search-clear');
      
      if (searchInput) {
        searchInput.addEventListener('input', function() {
          const searchTerm = this.value.toLowerCase().trim();
          const shouldShowClear = searchTerm.length > 0;
          
          if (searchClear) {
            searchClear.style.display = shouldShowClear ? 'flex' : 'none';
          }
          
          productCards.forEach(function(card) {
            const title = card.getAttribute('data-title').toLowerCase();
            const shouldShow = title.includes(searchTerm);
            card.style.display = shouldShow ? '' : 'none';
          });
        });
      }
      
      if (searchClear) {
        searchClear.addEventListener('click', function() {
          if (searchInput) {
            searchInput.value = '';
            this.style.display = 'none';
            productCards.forEach(function(card) {
              card.style.display = '';
            });
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-search"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionElements = document.querySelectorAll('[data-section-id]');
    
    sectionElements.forEach(function(sectionElement) {
      const searchInput = sectionElement.querySelector('[data-search-input]');
      const clearButton = sectionElement.querySelector('[data-search-clear]');
      
      if (!searchInput || !clearButton) return;

      // Fonction pour afficher/masquer le bouton clear
      function toggleClearButton() {
        if (searchInput.value.length > 0) {
          clearButton.classList.remove('hidden');
        } else {
          clearButton.classList.add('hidden');
        }
      }

      // Afficher le bouton si l'input a déjà une valeur (après recherche)
      toggleClearButton();

      // Écouter les changements dans l'input
      searchInput.addEventListener('input', toggleClearButton);
      searchInput.addEventListener('keyup', toggleClearButton);

      // Gérer le clic sur le bouton clear
      clearButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        searchInput.value = '';
        searchInput.focus();
        clearButton.classList.add('hidden');
        
        // Déclencher un événement input pour mettre à jour le predictive search
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
